import { render, staticRenderFns } from "./batchList.vue?vue&type=template&id=abb0fd2a&scoped=true"
import script from "./batchList.vue?vue&type=script&lang=js"
export * from "./batchList.vue?vue&type=script&lang=js"
import style0 from "./batchList.vue?vue&type=style&index=0&id=abb0fd2a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abb0fd2a",
  null
  
)

export default component.exports